import React from 'react';
import { useSelector } from 'react-redux';
import useAuthUsers from './useAuthUsers';

function useUserRole() {
  const { actualRol } = useSelector((state) => state.dagpacketRoles);
  const { currentHostUser, currentUser } = useAuthUsers();

  console.log(currentHostUser);

  const admitByUserType = (admitTypeArr) => {
    if (admitTypeArr.includes(actualRol?.userType)) {
      return true;
    }
    return false;
  };

  const admitByRoleName = (admitRoleNameArr, admitAssignedRoleName = []) => {
    if (admitRoleNameArr.includes(actualRol?.id)) {
      return true;
    }
    if (admitAssignedRoleName.includes(currentUser.role) && admitRoleNameArr.includes(currentHostUser?.role)) {
      return true;
    }
    return false;
  };

  return { actualRol, admitByUserType, admitByRoleName };
}

export default useUserRole;
